import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Row, Col, Card, InputNumber } from "antd";
import { DepenseService } from "../../services/DepenseService";
import { catchError } from "../../services/DaoService";
import Toast from "../../helpers/Toast";
import PropTypes from "prop-types";
import CustomFormItem from "../utils/form/CustomFormItem";

const DepenseEditForm = ({ visible, uid, onUpdate, onCancel }) => {
  const [form] = Form.useForm();
  const [editing, setEditing] = React.useState(false);
  const [validationErrors, setValidationErrors] = React.useState({});
  const [depense, setDepense] = useState(null);

  useEffect(() => {
    if (uid) {
      setEditing(true);
      DepenseService.getInstance()
        .find(uid)
        .then((response) => {
          form.setFieldsValue(response.data);
          setDepense(response.data);
        })
        .catch((error) => {
          catchError(error);
        })
        .finally(() => {
          setEditing(false);
        });
    }
  }, [uid, form]);

  const handleSave = () => {
    setEditing(true);
    form
      .validateFields()
      .then((values) => {
        DepenseService.getInstance()
          .update(uid, values)
          .then((response) => {
            Toast.success(response.message);
            onUpdate(response.data);
          })
          .catch((error) => {
            const errors = error.response.data;
            if (errors.validation && Object.keys(errors?.errors).length) {
              setValidationErrors(errors.errors);
            } else {
              catchError(error);
            }
          })
          .finally(() => {
            setEditing(false);
          });
      })
      .catch(() => {
        setEditing(false);
      });
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      okText="Enregistrer"
      onOk={handleSave}
      title="Modifier la dépense"
      forceRender
    >
      <Card loading={editing}>
        <Form layout="vertical" form={form} name="editDepenseForm">
          <Row gutter={16}>
            <Col xs={24} md={24}>
              <CustomFormItem
                label="Désignation"
                name="designation"
                rules={[{ required: true, message: "Veuillez saisir la désignation !" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input />
              </CustomFormItem>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <CustomFormItem
                label="Montant"
                name="montant"
                rules={[{ required: true, message: "Veuillez saisir le montant !" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <InputNumber className="w-100" min={0} suffix={depense?.affaire?.monnaie?.symbole} />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={12}>
              <CustomFormItem
                label="Date"
                name="date"
                rules={[{ required: true, message: "Veuillez saisir la date !" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="date" />
              </CustomFormItem>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={24}>
              <CustomFormItem
                label="Commentaire"
                name="commentaire"
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input.TextArea rows={4} />
              </CustomFormItem>
            </Col>
          </Row>
        </Form>
      </Card>
    </Modal>
  );
};

export default DepenseEditForm;

DepenseEditForm.propTypes = {
  visible: PropTypes.bool,
  onUpdate: PropTypes.func,
  onCancel: PropTypes.func,
  uid: PropTypes.string.isRequired,
};
